import { render, staticRenderFns } from "./EditProducerGeneralSetting.vue?vue&type=template&id=577dfed6&scoped=true&"
import script from "./EditProducerGeneralSetting.vue?vue&type=script&lang=js&"
export * from "./EditProducerGeneralSetting.vue?vue&type=script&lang=js&"
import style0 from "./EditProducerGeneralSetting.vue?vue&type=style&index=0&id=577dfed6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577dfed6",
  null
  
)

export default component.exports